import '@babel/polyfill';
import * as Config from './config';
import Axios from 'axios';
import isUndefined from 'lodash/isUndefined';
import Navigation from './modules/navigation';
import Newsletter from './modules/newsletter';
import FitText from './modules/fittext';
import BrandSlider from './modules/brand-slider';
import ConnectForm from './modules/connect/index';
import NewsletterForm from './modules/newsletter/index';
import Video from './modules/video';
import TeamMember from './modules/team-member';
import Timeline from './modules/timeline';
import NewsArticles from './modules/news-articles';
import Filters from './modules/filters';
import ScrollDown from './modules/scroll-down';
import CookieAlert from './modules/cookie-alert';
import ScrollOut from 'scroll-out';
import setupBreakpoints from './utils/setup-breakpoints';
import Stackla from './modules/stackla';

if (console && console.groupCollapsed) {
    console.groupCollapsed(`%c✨ treadright.org`, `color:#FFF;background-color:#000;padding:3px 5px;border-radius:3px;`);
    console.log(`I always loved to take things apart when I was younger; Rarely did I put them back together. You're here, you likely have a little of that in you too. Hit me up.`);
    console.log(`👻 • keith@zuul.ca • @mostlykeith • https://zuul.ca/`);
    console.log(`%c${Config.get('name')}::${Config.get('env')}`, `color:#FFF;background-color:#F60;border-radius:3px;font-size:10px;padding:3px;`, `Version: ${Config.get('release')}.`);
    console.groupEnd();
}

const go = async () => {
    try {
        const {data} = await Axios.get(`${Config.get('themeDirectory')}/dist/icons/icons.xml`);
        const iconsNode = document.createElement('div');

        document.body.classList.add('js-ready');

        iconsNode.id = 'icons-wrap';
        iconsNode.innerHTML = data;

        document.body.appendChild(iconsNode);

        ScrollOut({
        });

        setupBreakpoints(Config.get('breakpoints'));

        const Modules = {
            Navigation,
            Newsletter,
            Video,
            FitText,
            NewsArticles,
            Filters,
            TeamMember,
            Timeline,
            Stackla,
            ScrollDown,
            BrandSlider,
            NewsletterForm,
            ConnectForm
        };
        const moduleElements = document.querySelectorAll('[data-module]');

        for (let i = 0; i < moduleElements.length; i++) {
            const el = moduleElements[i];
            const options = !isUndefined(el.getAttribute('data-module-options')) ? JSON.parse(el.getAttribute('data-module-options')) : null;
            const names = el.getAttribute('data-module').split(' ');

            names.forEach(name => { // eslint-disable-line no-loop-func
                if (!isUndefined(Modules[name])) {
                    const params = { // eslint-disable-line no-new
                        el
                    };

                    if (options) {
                        params.options = options;
                    }

                    new Modules[name](params);
                }
            });
        }

        new CookieAlert({ // eslint-disable-line no-new
            strings: {
                message: 'This website uses cookies to ensure you get the best experience on our website. <a href="/privacy-policy/">More information</a>',
                buttonText: 'Got it!'
            },
            buttonAction: '#'
        });
    } catch (e) {
        console.log(e);
    }
};

go();

